import { config } from '../config'

export const key = (...args: unknown[]) => [config.modelName, ...args]
